import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  EventEmitter,
  Output,
  Input,
  HostListener,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { Subject, Observable, BehaviorSubject } from "rxjs";
import * as _ from "underscore";
import { RootStoreState } from "src/app/root-store";
import {
  getFpProjectCategoryError,
  getFpProjectCategoryList,
  getFpProjectCategoryListLoading,
  getFpProjectExtrasList,
  getFpProjectExtrasListError,
  getFpProjectExtrasListLoading,
  getFpProjectSizeList,
  getFpProjectSizeListError,
  getFpProjectSizeListLoading,
  getFpProjectSubCategoryList,
  getFpProjectSubCategoryListError,
  getFpProjectSubCategoryListLoading,
  getFpProjectCategorySize,
  getFpProjectCategorySizeLoading,
  getFpProjectCategorySizeError,
  getFpProjectList,
  getFpProjectListLoading,
  getFpProjectListError,
  getFpProjectPriceList,
  getFpProjectPriceListError,
  getFpProjectPriceListLoading,
  getCreatedPurchaseLineItemsError,
  getCreatedPurchaseLineItemsLoading,
  getCreatedPurchaseLineItems,
  getCreatedLineItemConfigs,
  getCreatedLineItemConfigsError,
  getCreatedLineItemConfigsLoading,
  updatePurchaseLineItemError,
  updatePurchaseLineItemLoading,
  updatePurchaseLineItemSuccess,
} from "src/app/root-store/kwikspace-app-store/selectors/purchase.selector";
import { takeUntil } from "rxjs/operators";
import {
  GetFpProjectCategory,
  GetFpProjectExtras,
  GetFpProjectSize,
  GetFpProjectSubCategory,
  GetFpCategorySize,
  GetFpProjectLists,
  GetFpProjectPriceLists,
  CreatePurchaseLineItem,
  CreatePurchaseLineItemConfig,
  UpdatePurchaseLineItem,
} from "src/app/root-store/kwikspace-app-store/actions/purchase.action";
import { FpProjectCategory } from "src/app/models/FpProjectCategory.model";
import { FpProjectSubCategory } from "src/app/models/FpProjectSubCategory.model";
import { FpProjectSize } from "src/app/models/FpProjectSize.model";
import { FpProjectExtra } from "src/app/models/FpProjectExtra.model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ColumnConfigItem } from "src/app/models/ColumnConfigItem";
import { FloorplannerProject } from "src/app/models/Floorplanner.model";
import { ModalComponent } from "src/app/core/components/modal/modal.component";
import { getCreatedPurchaseQuote } from "src/app/root-store/kwikspace-app-store/selectors/quote.selector";
import {
  ClearTransportPriceList,
  GetTransportLoads,
  GetTransportOptions,
  GetTransportPriceList,
} from "src/app/root-store/kwikspace-app-store/actions/transport.action";
import {
  getTransportLoads,
  getTransportLoadsError,
  getTransportLoadsLoading,
  getTransportOptions,
  getTransportOptionsError,
  getTransportOptionsLoading,
  getTransportPriceList,
  getTransportPriceLoading,
} from "src/app/root-store/kwikspace-app-store/selectors/transport.selector";
import { getProvinces } from "src/app/root-store/kwikspace-app-store/selectors/kwikspace.selector";
import { AppRoutes } from "src/app/shared/endpoints.enum";
import { TanToastrService } from "src/app/services/toastr.service";
import { Quote } from "src/app/models/Quote.model";
import { UnitSizeConstants } from "src/app/shared/string-constants";

@Component({
  selector: "app-existing-templates",
  templateUrl: "./existing-templates.component.html",
  styleUrls: ["./existing-templates.component.scss"],
})
export class ExistingTemplatesComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject();

  @ViewChild("viewProjectImgModal", { static: false })
  viewProjectImgModal: ModalComponent;

  @ViewChild("addProjectQtyModal", { static: false })
  addProjectQtyModal: ModalComponent;

  @ViewChild("removeUnitModal", { static: false })
  removeUnitModal: ModalComponent;

  @ViewChild("addUnitModal", { static: false })
  addUnitModal: ModalComponent;

  @ViewChild("confirmUnitSizes", { static: false })
  confirmUnitSizes: ModalComponent;

  @Output() onSelectItem = new EventEmitter<any>();

  @Output() createDiagram = new EventEmitter<any>();

  fpProjectCategoryLoading$: Observable<any> = this.store.select(
    getFpProjectCategoryListLoading
  );

  fpProjectCategoryError$: Observable<any> = this.store.select(
    getFpProjectCategoryError
  );

  fpProjectCategorySizeLoading$: Observable<any> = this.store.select(
    getFpProjectCategorySizeLoading
  );

  fpProjectCategorySizeError$: Observable<any> = this.store.select(
    getFpProjectCategorySizeError
  );

  fpProjectSubCategoryLoading$: Observable<any> = this.store.select(
    getFpProjectSubCategoryListLoading
  );

  fpProjectSubCategoryError$: Observable<any> = this.store.select(
    getFpProjectSubCategoryListError
  );

  fpProjectSizeLoading$: Observable<any> = this.store.select(
    getFpProjectSizeListLoading
  );

  fpProjectSizeError$: Observable<any> = this.store.select(
    getFpProjectSizeListError
  );

  fpProjectExtrasLoading$: Observable<any> = this.store.select(
    getFpProjectExtrasListLoading
  );

  fpProjectExtrasError$: Observable<any> = this.store.select(
    getFpProjectExtrasListError
  );

  fpProjectListLoading$: Observable<any> = this.store.select(
    getFpProjectListLoading
  );

  fpProjectListError$: Observable<any> = this.store.select(
    getFpProjectListError
  );

  fpProjectPriceListLoading$: Observable<any> = this.store.select(
    getFpProjectPriceListLoading
  );

  fpProjectPriceListError$: Observable<any> = this.store.select(
    getFpProjectPriceListError
  );

  transportOptionsLoading$: Observable<any> = this.store.select(
    getTransportOptionsLoading
  );
  transportOptionsError$: Observable<any> = this.store.select(
    getTransportOptionsError
  );

  transportLoadsLoading$: Observable<any> = this.store.select(
    getTransportLoadsLoading
  );
  transportLoadsError$: Observable<any> = this.store.select(
    getTransportLoadsError
  );

  createLineItemLoading$: Observable<any> = this.store.select(
    getCreatedPurchaseLineItemsLoading
  );
  createLineItemError$: Observable<any> = this.store.select(
    getCreatedPurchaseLineItemsError
  );

  createLineItemConfigLoading$: Observable<any> = this.store.select(
    getCreatedLineItemConfigsLoading
  );
  createLineItemConfigError$: Observable<any> = this.store.select(
    getCreatedLineItemConfigsError
  );

  updatePurchaseLineItemLoading$: Observable<any> = this.store.select(
    updatePurchaseLineItemLoading
  );
  updatePurchaseLineItemError$: Observable<any> = this.store.select(
    updatePurchaseLineItemError
  );

  quoteNumber: any = null;
  createdQuote: any = null;
  provinces: any[] = [];

  pageCount = 1;
  pageLinks;
  itemCount = 0;
  currentPage = 1;
  pageToLoad;

  purchaseForm: FormGroup;

  fpProjectCategories: FpProjectCategory[] = [];
  fpProjectSubCategories: FpProjectSubCategory[] = [];
  fpProjectSizes: FpProjectSize[] = [];
  fpProjectExtras: FpProjectExtra[];

  columnConfig: ColumnConfigItem[];

  showQty: boolean = false;
  qtyEntered: boolean = false;
  projectSelected: boolean = false;
  displayExtras: boolean = false;
  extrasLoading: boolean = false;
  selectedFpProject: any = null;
  selectedFpProjectCategoryId: any = null;
  selectedFpProjectCategoryName: any = null;
  selectedFpProjectSubCategoryId: any = null;
  selectedFpProjectSubCategoryName: any = null;
  selectedFpProjectSizeId: any = null;
  selectedFpProjectSizeName: any = null;
  selectedFpProjectExtraId: any = null;
  selectedFpProjectExtraName: any = null;
  projectIDSelected: number = null;

  selectedFpProjectCategory: boolean = false;
  selectedFpProjectSubCategory: boolean = false;
  selectedFpProjectSize: boolean = false;
  selectedFpProjectExtra: boolean = false;
  selectedTemplateOption: any = null;

  showProjectsTable: boolean = false;
  showFpProjectSubCategories: boolean = false;
  showSubCat: boolean = false;

  projects: FloorplannerProject[] = [];
  projectList: FloorplannerProject[] = [];
  projectLabels: any[] = [];

  projectToView: any = null;
  projectProducts: any[] = [];

  renderProjectTable: boolean = false;
  diagramOptionSelected: boolean = false;
  selectedDiagramOption: string = "";
  createFloorplanner: boolean = false;
  existingProjects: boolean = false;

  quoteLineItem: any = {};
  quoteLineItemProducts: any[] = [];
  quoteCart: any[] = [];
  addedLineItems: any[] = [];
  addOnsToAdd: number = 0;
  unitSizes: string[] = [];

  canSave: boolean = false;
  unitQty: number = 0;

  showTransport: boolean = false;
  hasTransportPricing: boolean = false;
  hasProjectPricing: boolean = false;
  hasShipping: boolean = false;

  selectedTransportLoad = null;
  selectedTransportOption = null;
  selectedTransportJoinOption = null;
  selectedTransportExtraOption = null;
  selectedTransportLoadOne = null;
  selectedTransportLoadTwo = null;
  transportOneLoading: boolean = false;
  transportOneHasPricing: boolean = false;
  transportTwoLoading: boolean = false;
  transportTwoHasPricing: boolean = false;
  addSecondTransportLoad: boolean = false;
  editingTransportLoad = null;
  transportType = "load1";

  transportPricing: any[] = [];
  transportVariations: any[] = [];
  transportLoads: any[] = [];
  transportLoadError: boolean = false;

  showTemplateOption: boolean = false;

  addingToCart: boolean = false;

  selectedModalLineItem = null;
  selectedModalLineItemExtra = null;
  selectedUnit: any = null;
  quote: Quote = null;

  isMobile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    window.innerWidth <= 768
  );

  @HostListener("window:resize", ["$event"])
  setIsMobile(event) {
    const isMobile = event.target.innerWidth <= 768;
    this.isMobile.next(isMobile);
  }

  constructor(
    private store: Store<RootStoreState.RootState>,
    private router: Router,
    private formBuilder: FormBuilder,
    private toastrService: TanToastrService
  ) { }

  ngOnInit() {
    this.getProjectCategories();

    this.store
      .select(getCreatedPurchaseQuote)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((quote) => {
        if (quote) {
          this.createdQuote = quote;
          this.quoteNumber = this.createdQuote.quote_number;

          if (
            this.createdQuote.shipping_province != "Other" &&
            this.createdQuote.shipping_province != null &&
            this.createdQuote.shipping == true
          ) {
            this.hasShipping = true;
            this.getTransportLoads();
          }
        }
      });

    this.store
      .select(getProvinces)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((provinces: any) => {
        if (provinces?.results) {
          this.provinces = provinces.results;
        }
      });

    // this.store
    //   .select(getTransportPriceList)
    //   .pipe(takeUntil(this.ngUnsubscribe))
    //   .subscribe((transports: any) => {
    //     debugger
    //     if (transports?.results?.length > 0) {
    //       if (
    //         this.transportType === "load1" &&
    //         this.selectedTransportLoadOne !== null &&
    //         this.selectedTransportLoadOne.results === null
    //       ) {
    //         this.filterTransportList(
    //           "load1",
    //           transports.results,
    //           this.editingTransportLoad
    //         );
    //       } else if (
    //         this.transportType === "load2" &&
    //         this.selectedTransportLoadTwo !== null &&
    //         this.selectedTransportLoadTwo.results === null
    //       ) {
    //         this.filterTransportList(
    //           "load2",
    //           transports.results,
    //           this.editingTransportLoad
    //         );
    //       }
    //     } else if (transports?.results?.length === 0) {
    //       if (this.transportType === "load1") {
    //         this.transportOneHasPricing = false;
    //         this.transportOneLoading = false;
    //       } else if (this.transportType === "load2") {
    //         this.transportTwoHasPricing = false;
    //         this.transportTwoLoading = false;
    //       }
    //     }
    //   });

    this.purchaseForm = this.formBuilder.group({
      project_category: [null, [Validators.required]],
      project_sub_category: [null, [Validators.required]],
      project_size: [null, [Validators.required]],
      project_extra: [null, []],
      template_option: [null, []],
      quantity: [null, [Validators.required]],
      transport_load_one: [null, [Validators.required]],
      transport_load_one_qty: [null, [Validators.required]],
      transport_load_two: [null, []],
      transport_load_two_qty: [null, []],
    });

    this.columnConfig = [
      {
        oldName: "floorplannerProjectId",
        isVisible: false,
      },
      {
        oldName: "user",
        isVisible: false,
      },
      {
        oldName: "public",
        isVisible: false,
      },
      {
        oldName: "description",
        isVisible: true,
      },
      {
        oldName: "projectUrl",
        isVisible: false,
      },
      {
        oldName: "createdAt",
        isVisible: false,
      },
      {
        oldName: "updatedAt",
        isVisible: false,
      },
      {
        oldName: "thumbnail",
        isVisible: false,
      },
      {
        oldName: "thumbnail3d",
        isVisible: false,
      },
      {
        oldName: "legacyEditor",
        isVisible: false,
      },
      {
        oldName: "products",
        isVisible: false,
      },
      {
        oldName: "labels",
        isVisible: false,
      },
    ];
    // this.getTransportLoads();
  }

  getTransportLoads() {
    this.store.dispatch(new GetTransportLoads());

    this.store
      .select(getTransportLoads)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((loads: any) => {
        if (loads?.length > 0) {
          this.transportLoads = loads.filter(
            (loadSize) => loadSize.available == true
          );
          this.transportLoads = this.transportLoads.filter(
            (loadSize) => loadSize.hasPurchase == true
          );
        }
      });
  }

  getProjectCategories() {
    this.store
      .select(getFpProjectCategoryList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((categories) => {
        if (categories) {
          this.fpProjectCategories = categories.filter(
            (item) => item.name !== "Shell"
          );
        }
      });
    this.store.dispatch(new GetFpProjectCategory());
  }

  getProjectSubCategories() {
    this.store
      .select(getFpProjectSubCategoryList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((sub_cats) => {
        if (sub_cats && sub_cats.length > 0) {
          let sub_categories = [];

          sub_cats.forEach((cat) => {
            let sub_cat = cat.subCategory;
            sub_categories.push(sub_cat);
          });

          this.fpProjectSubCategories = sub_categories.filter(
            (sub_cat, index) => {
              return sub_categories.indexOf(sub_cat) === index;
            }
          );

          this.fpProjectSubCategories = sub_categories.filter(
            (v, i) =>
              sub_categories.findIndex((item) => item.name == v.name) === i
          );
        }
      });
    let payload = {
      category: `?category=${this.selectedFpProjectCategoryId}`,
    };
    this.store.dispatch(new GetFpProjectSubCategory(payload));
  }

  getProjectSizes() {
    this.store
      .select(getFpProjectSizeList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((cat_sizes) => {
        if (cat_sizes && cat_sizes.length > 0) {
          let sizes = [];

          this.unitSizes = cat_sizes;

          cat_sizes.forEach((size) => {
            let sub_cat = size.size;
            sizes.push(sub_cat);
          });

          this.fpProjectSizes = sizes.filter((sub_cat, index) => {
            return sizes.indexOf(sub_cat) === index;
          });
        }
      });

    let payload = {
      category: `?category=${this.selectedFpProjectCategoryId}&sub_category=${this.selectedFpProjectSubCategoryId}`,
    };
    this.store.dispatch(new GetFpProjectSize(payload));
  }

  getProjectExtras() {
    this.store
      .select(getFpProjectExtrasList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((variations) => {
        if (variations && variations.length > 0) {
          let filteredVariations = [];
          variations.forEach((option) => {
            let variationName = option.name;
            if (this.projectLabels.includes(variationName)) {
              filteredVariations.push(option);
            }
          });
          this.fpProjectExtras = filteredVariations;
          this.extrasLoading = false;
          this.displayExtras = true;
        }
      });
    this.store.dispatch(new GetFpProjectExtras());
  }

  setFpProjectCategory() {
    this.selectedFpProjectCategoryId =
      this.purchaseForm.value.project_category.id;
    this.selectedFpProjectCategoryName =
      this.purchaseForm.value.project_category.name;
    this.selectedFpProjectCategory = true;

    this.selectedFpProjectSubCategoryId = null;
    this.selectedFpProjectSubCategoryName = "";
    this.selectedFpProjectSizeId = null;
    this.selectedFpProjectSizeName = "";
    this.selectedFpProjectExtraId = null;
    this.selectedFpProjectExtraName = "";

    this.selectedFpProjectSubCategory = false;
    this.selectedFpProjectSize = false;
    this.selectedFpProjectExtra = false;
    this.showTemplateOption = false;
    this.selectedTemplateOption = {};
    this.displayExtras = false;

    this.showQty = false;
    this.projects = [];

    this.getProjectSubCategories();
  }

  setFpProjectSubCategory() {
    this.selectedFpProjectSubCategoryId =
      this.purchaseForm.value.project_sub_category.id;
    this.selectedFpProjectSubCategoryName =
      this.purchaseForm.value.project_sub_category.name;
    this.selectedFpProjectSubCategory = true;

    this.selectedFpProjectSizeId = null;
    this.selectedFpProjectSizeName = "";
    this.selectedFpProjectExtraId = null;
    this.selectedFpProjectExtraName = "";

    this.selectedFpProjectSize = false;
    this.selectedFpProjectExtra = false;
    this.showTemplateOption = false;
    this.selectedTemplateOption = {};
    this.displayExtras = false;

    this.showQty = false;
    this.projects = [];

    this.getProjectSizes();
  }

  setFpProjectSize() {
    this.selectedFpProjectSizeId = this.purchaseForm.value.project_size.id;
    this.selectedFpProjectSizeName = this.purchaseForm.value.project_size.size;
    this.selectedFpProjectSize = true;

    this.selectedFpProjectExtraId = null;
    this.selectedFpProjectExtraName = "";

    this.selectedFpProjectExtra = false;
    this.showTemplateOption = false;
    this.selectedTemplateOption = {};
    this.displayExtras = false;

    this.showQty = false;
    this.projects = [];

    this.getProjectListForVariations();
  }

  setFpProjectExtra() {
    this.selectedFpProjectExtraId = this.purchaseForm.value.project_extra.id;
    this.selectedFpProjectExtraName =
      this.purchaseForm.value.project_extra.name;
    this.selectedFpProjectExtra = true;

    this.showQty = true;

    this.getProjectList();
  }

  getProjectListForVariations() {
    this.extrasLoading = true;
    if (
      this.selectedFpProjectCategoryId != null &&
      this.selectedFpProjectSubCategoryId != null &&
      this.selectedFpProjectSizeId != null
    ) {
      this.store
        .select(getFpProjectList)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((projects: any) => {
          if (projects?.results?.length > 0) {
            if (this.projects.length == 0) {
              projects.results.forEach((proj) => {
                let labels = proj.labels[0].description;
                this.projectLabels.push(labels);
              });
              this.getProjectExtras();
            }
          }
        });
      let payload = {
        category: `?category=${this.selectedFpProjectCategoryName}`,
        sub_category: `&sub_category=${encodeURIComponent(
          this.selectedFpProjectSubCategoryName
        )}`,
        size: `&size=${this.selectedFpProjectSizeName}`,
      };
      this.store.dispatch(new GetFpProjectLists(payload));
    }
  }

  getProjectList() {
    this.showProjectsTable = false;

    if (
      this.selectedFpProjectCategoryId != null &&
      this.selectedFpProjectSubCategoryId != null &&
      this.selectedFpProjectSizeId != null &&
      this.selectedFpProjectExtraId != null
    ) {
      this.store
        .select(getFpProjectList)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((projects: any) => {
          if (projects?.results?.length > 0) {
            this.projects = projects.results;
            this.showProjectsTable = true;
          } else {
            this.showProjectsTable = false;
          }
        });
      let payload = {
        category: `?category=${this.selectedFpProjectCategoryName}`,
        sub_category: `&sub_category=${encodeURIComponent(
          this.selectedFpProjectSubCategoryName
        )}`,
        size: `&size=${this.selectedFpProjectSizeName}`,
        variation: `&description=${this.selectedFpProjectExtraName}`,
      };
      this.store.dispatch(new GetFpProjectLists(payload));
    }
  }

  setTemplateOption() {
    const templateOptionId = this.purchaseForm.value.template_option;
    const _id = this.projects.findIndex(
      (obj) => obj.floorplannerProjectId == templateOptionId
    );
    this.selectedTemplateOption = this.projects[_id];
    this.showTemplateOption = true;

    let project = {
      ...this.selectedTemplateOption,
      unit: "Unit " + (this.quoteCart.length + 1),
      idx: this.quoteCart.length + 1,
      mappedProducts: this.mapProducts(this.selectedTemplateOption.products),
      drawingNumber: "",
      size: this.selectedFpProjectSizeName,
      variation: this.selectedFpProjectExtraName,
      price: 0,
      quantity: this.unitQty,
      isTemplate: true,
      transportOne: "",
      transportTwo: "",
      transportJoin: "",
      transportExtra: "",
    };

    this.selectedFpProject = project;
    this.projectSelected = true;

    this.addItemProducts();
    this.getTemplateProjectPricing();

    if (this.createdQuote.shipping_province != "Other" &&
      this.createdQuote.shipping_province != null &&
      this.createdQuote.shipping == true) {
      this.getTransportOptions();
    }
    // this.getTransportOptions();
  }

  viewItem() {
    this.projectToView = this.selectedTemplateOption;
    this.projectProducts = this.mapProducts(
      this.selectedTemplateOption.products
    );
    this.viewProjectImgModal.open();
  }

  addAnotherTruck() {
    this.addSecondTransportLoad = true;
  }

  setSelectedTransportLoadOne() {
    this.selectedTransportLoadOne = {
      load: this.purchaseForm.value.transport_load_one,
      quantity: this.purchaseForm.value.transport_load_one_qty,
      results: null,
    };
    if (
      this.selectedTransportLoadOne.load &&
      this.selectedTransportLoadOne.quantity
    ) {
      this.transportOneLoading = true;
      this.transportOneHasPricing = false;
      this.transportType = "load1";
      this.editingTransportLoad = this.selectedTransportLoadOne;
      this.calculateTransportPricing();
    }
  }

  setSelectedTransportLoadTwo() {
    this.selectedTransportLoadTwo = {
      load: this.purchaseForm.value.transport_load_two,
      quantity: this.purchaseForm.value.transport_load_two_qty,
      results: null,
    };
    if (
      this.selectedTransportLoadTwo.load &&
      this.selectedTransportLoadTwo.quantity
    ) {
      this.transportTwoLoading = true;
      this.transportTwoHasPricing = false;
      this.transportType = "load2";
      this.editingTransportLoad = this.selectedTransportLoadTwo;
      this.calculateTransportPricing();
    }
  }

  calculateTransportPricing() {

    this.store
      .select(getTransportPriceList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((transports: any) => {
        if (transports?.results?.length > 0) {
          if (
            this.transportType === "load1" &&
            this.editingTransportLoad !== null &&
            this.editingTransportLoad.results === null
          ) {
            this.filterTransportList(
              "load1",
              transports.results,
              this.editingTransportLoad
            );
          } else if (
            this.transportType === "load2" &&
            this.editingTransportLoad !== null &&
            this.editingTransportLoad.results === null
          ) {
            this.filterTransportList(
              "load2",
              transports.results,
              this.editingTransportLoad
            );
          }
        } else if (transports?.results?.length === 0) {
          if (this.transportType === "load1") {
            this.transportOneHasPricing = false;
            this.transportOneLoading = false;
          } else if (this.transportType === "load2") {
            this.transportTwoHasPricing = false;
            this.transportTwoLoading = false;
          }
        }
      });

    const shipping_area = this.createdQuote.shipping_area
      ? `&transport_location=${this.createdQuote.shipping_area}`
      : "";
    const params = `?load_size=${this.selectedTransportLoadOne.load}${shipping_area}`;

    this.store.dispatch(new GetTransportPriceList(params));
  }

  filterTransportList(type, transportResults, load) {
    let filteredArray = [];
    transportResults.forEach((price) => {
      if (
        price.priceType.name == "Both" ||
        price.priceType.name == "Purchase"
      ) {
        if (price.transportCharge.name == "Transport") {
          filteredArray.push(price);
        }
      }
    });

    if (type === "load1") {
      if (filteredArray.length === 0) {
        this.transportOneLoading = false;
        this.transportOneHasPricing = false;
        this.showTemplateOption =
          this.selectedTemplateOption != null ? true : false;
        return;
      }

      this.selectedTransportLoadOne = this.editingTransportLoad;
      this.selectedTransportLoadOne.results = filteredArray[0];

      const transport = {
        id: this.selectedTransportLoadOne.results.id,
        transport: this.selectedTransportLoadOne.results,
        quantity: load.quantity,
      };

      this.quoteLineItem.transportOne = transport;
      this.transportOneLoading = false;
      this.transportOneHasPricing = true;
      this.showTemplateOption =
        this.selectedTemplateOption != null ? true : false;
    } else if (type === "load2") {
      if (filteredArray.length === 0) {
        this.transportTwoLoading = false;
        this.transportTwoHasPricing = false;
        this.showTemplateOption =
          this.selectedTemplateOption != null ? true : false;
        return;
      }

      this.selectedTransportLoadTwo = this.editingTransportLoad;
      this.selectedTransportLoadTwo.results = filteredArray[0];

      const transport = {
        id: this.selectedTransportLoadTwo.results.id,
        transport: this.selectedTransportLoadTwo.results,
        quantity: load.quantity,
      };

      this.quoteLineItem.transportTwo = transport;
      this.transportTwoLoading = false;
      this.transportTwoHasPricing = true;
      this.showTemplateOption =
        this.selectedTemplateOption != null ? true : false;
    }
  }

  setUnitQty() {
    this.unitQty =
      this.purchaseForm.value.quantity != "" &&
        this.purchaseForm.value.quantity > 0
        ? this.purchaseForm.value.quantity
        : 1;

    this.qtyEntered = true;
  }

  addToCart() {
    this.addingToCart = true;
    if (this.createdQuote.shipping && this.createdQuote.shipping_province != null) {
      const _id = this.provinces.findIndex(
        (obj) => obj.id == this.createdQuote.shipping_province
      );

      const province = this.provinces[_id].name;
      if (province != "Other") {
        this.getTransportOptions();
      }
    } else {
      this.saveToCart();
    }
  }

  saveToCart() {
    // get the template price
    if (!this.hasJoining()) {
      this.selectedFpProject.transportJoin = "";
    }
    if (this.selectedFpProject.variation == "Standard") {
      this.selectedFpProject.transportExtra = "";
    }
    this.quoteCart.push(this.selectedFpProject);

    this.purchaseForm.reset();

    this.selectedFpProject = null;
    this.selectedFpProjectCategoryId = null;
    this.selectedFpProjectSubCategoryId = null;
    this.selectedFpProjectSizeId = null;
    this.selectedFpProjectExtraId = null;
    this.selectedTemplateOption = null;

    this.projectSelected = false;
    this.qtyEntered = false;
    this.showQty = false;
    this.addSecondTransportLoad = false;
    this.selectedFpProjectCategory = false;
    this.selectedFpProjectSubCategory = false;
    this.selectedFpProjectSize = false;
    this.selectedFpProjectExtra = false;
    this.transportOneLoading = false;
    this.transportOneHasPricing = false;
    this.transportTwoLoading = false;
    this.transportTwoHasPricing = false;
    this.selectedTransportLoadOne = null;
    this.selectedTransportLoadTwo = null;
    this.selectedTransportLoad = null;
    this.selectedTransportOption = null;
    this.selectedTransportJoinOption = null;
    this.selectedTransportExtraOption = null;

    this.showTransport = false;
    this.hasTransportPricing = false;
    this.hasProjectPricing = false;
    this.hasShipping = false;

    this.addingToCart = false;
    this.showTemplateOption = false;
    this.canSave = this.quoteCart.length > 0 ? true : false;

    this.displayExtras = false;

    this.projects = [];

    this.unitQty = 0;
    this.purchaseForm.value.quantity = '';
  }

  mapProducts(products) {
    let mappedProducts = [];

    products.forEach((product) => {
      let productAdded = mappedProducts.some((el) => el.sku === product.sku);
      if (productAdded) {
        const idx = mappedProducts.findIndex((x) => x.sku === product.sku);
        mappedProducts[idx].qty += 1;
      } else {
        let _product = { ...product, qty: 1 };
        mappedProducts.push(_product);
      }
    });

    return mappedProducts;
  }

  getTemplateProjectPricing() {
    this.store
      .select(getFpProjectPriceList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((pricing: any) => {
        if (pricing) {
          if (pricing.length > 0) {
            this.selectedFpProject.price = this.addProjectPrice(pricing[0]);
            this.selectedFpProject.drawingNumber = pricing[0].drawingNumber;
            this.hasProjectPricing = true;
          }
        }
      });

    const payload = {
      category: `?category=${this.selectedFpProjectCategoryId}`,
      sub_category: `&sub_category=${this.selectedFpProjectSubCategoryId}`,
      size: `&size=${this.selectedFpProjectSizeId}`,
      variation: `&charge_variation=${this.selectedFpProjectExtraId}`,
    };
    this.store.dispatch(new GetFpProjectPriceLists(payload));
  }

  addProjectPrice(projectPrice) {
    let price = 0;

    if (this.createdQuote.shipping_province == 'Other' || this.createdQuote.shipping_province == null) {
      price = projectPrice.standardPrice;
    } else if (this.createdQuote.shipping) {
      const _id = this.provinces.findIndex(
        (obj) => obj.id == this.createdQuote.shipping_province
      );

      const province = this.provinces[_id].name;

      price =
        province != "Western Cape"
          ? projectPrice.standardPrice
          : projectPrice.cptPrice;
    } else {
      price = projectPrice.cptPrice;
    }

    return price;
  }

  calculateLoadSize() {
    let match;
    const size = this.selectedFpProject.size;

    let min = size.split("m x")[0];
    let max = size.split("x")[1];
    max = max.replace("m", "");
    min = parseInt(min);
    max = parseInt(max);

    // look for an exact match
    match = this.getPerfectMatch(min, max);

    if (match != null) {
      this.selectedTransportLoad = match;

      return true;
    } else {
      // no exact match found, look for closest match
      match = this.findClosestMatch(min, max);
      if (match != null) {
        this.selectedTransportLoad = match;

        return true;
      } else {
        // no matches found, select load size manually
        this.transportLoadError = true;

        return false;
      }
    }
  }

  getPerfectMatch(unitWidth, unitLength) {
    let _id = null;

    for (let i = 0; i < this.transportLoads.length; i++) {
      let loadSize = this.transportLoads[i].size;

      let length = loadSize.split("m x")[0].replace(/\s/g, "");
      let width = loadSize.split("x")[1].replace(/\s/g, "").charAt(0);
      length = parseInt(length);
      width = parseInt(width);

      if (unitWidth == width && unitLength == length) {
        _id = this.transportLoads[i].id;
        break;
      }
    }

    return _id;
  }

  findClosestMatch(unitWidth, unitLength) {
    let _id = null;
    let matchedItems = [];

    for (let i = 0; i < this.transportLoads.length; i++) {
      let loadSize = this.transportLoads[i].size;

      let length = loadSize.split("m x")[0].replace(/\s/g, "");
      let width = loadSize.split("x")[1].replace(/\s/g, "").charAt(0);
      length = parseInt(length);
      width = parseInt(width);

      if (unitLength <= length + 0.1 && unitWidth <= width + 0.1) {
        matchedItems.push(this.transportLoads[i]);
      }
    }

    if (matchedItems.length > 0) {
      matchedItems.sort((a, b) => (a.size > b.size ? 1 : -1));
      _id = matchedItems[0].id;
    }

    return _id;
  }

  getTransportOptions() {
    this.store.dispatch(new GetTransportOptions());

    this.store
      .select(getTransportOptions)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((options: any) => {
        if (options && options.length > 0) {
          let transportId: any = null;
          let transportJoinId: any = null;
          let transportChargeList: any = [];

          options.forEach((option) => {
            if (option.name == "Transport") {
              transportId = option.id;
            } else {
              transportChargeList.push(option);
            }
          });

          this.selectedTransportOption = transportId;
          this.selectedTransportJoinOption = transportJoinId;
          this.selectedTransportExtraOption =
            this.getOptionalTransportFee(transportChargeList);

          if (this.selectedTransportOption != null) {
            this.getTransportPricing();
          }
        }
      });
  }

  getOptionalTransportFee(transportChargeList) {
    let chargeIdx = null;
    let id = null;
    const projectCharge = this.selectedFpProject.variation.toLowerCase(); // variation option

    if (projectCharge != "standard") {
      transportChargeList.forEach((option, idx) => {
        const transportCharge = option.name.toLowerCase();
        chargeIdx =
          transportCharge.search(projectCharge) != -1 ? idx : chargeIdx;
      });

      // id = transportChargeList[chargeIdx].id;

      if (chargeIdx == null) {
        const _optionalExtras = "travel & siting, including fitment of optional extra's";
        transportChargeList.forEach((option, idx) => {
          const transportCharge = option.name.toLowerCase();
          chargeIdx =
            transportCharge.search(_optionalExtras) != -1 ? idx : chargeIdx;
        });
      }

      id = chargeIdx != null ? transportChargeList[chargeIdx].id : transportChargeList[0].id;
    }



    // TODO
    // KZN, umgundlovu, pietermatirzburg - not calculating
    // standard unit
    // confirm spelling - should not have durban, should be Kwazulu Natal

    // if (charge == -1) {
    //   // there is only one charge
    //   if (projectCharge != "standard") {
    //     id = this.transportVariations.findIndex(
    //       (obj) => obj.name.toLowerCase() == projectCharge
    //     );
    //   }
    // } else {
    //   // there is more than one charge
    //   transportChargeList.forEach((name) => {
    //     const transportCharge = name.toLowerCase();
    //     count =
    //       transportCharge.search(projectCharge) != -1 ? (count += 1) : count;
    //   });

    //   id = this.transportVariations.findIndex((obj) => obj.id == 1);
    // }

    return id;
  }

  hasJoining() {
    let join = false;

    const size = this.selectedFpProject.size;

    let min = size.split("m x")[0];
    min = parseInt(min);
    join = min > 3 ? true : false;

    return join;
  }

  getTransportPricing() {
    this.store.dispatch(new ClearTransportPriceList());

    if (this.transportLoads.length > 0) {
      const params = `?load_size=${this.selectedTransportLoad}&transport_location=${this.createdQuote.shipping_area}`;
      this.store.dispatch(new GetTransportPriceList(params));
    }

    this.store
      .select(getTransportPriceList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((transports: any) => {
        if (transports && transports.results) {
          if (transports.results.length > 0) {
            this.transportPricing = [];

            transports.results.forEach((price) => {
              if (
                price.priceType.name == "Both" ||
                price.priceType.name == "Purchase"
              ) {
                this.transportPricing.push(price);
                // if (
                //   price.transportCharge.name == "Transport" ||
                //   price.transportCharge.name ==
                //   "Travel & Siting (Joining) on site"
                // ) {
                //   this.transportPricing.push(price);
                // }
              }
            });

            this.hasTransportPricing =
              this.transportPricing.length > 0 ? true : false;
            this.setTransportPricing();
          }
        }
      });
  }

  setTransportPricing() {
    if (this.transportPricing.length > 0) {
      this.setTransportOption();
    }
    // else {
    //   this.showTransportCharge = true;
    // }
  }

  setTransportOption() {
    // debugger
    let _id;
    let _option;
    // let _transportOption = null;
    // let _transportOptionJoin = null;

    for (let i = 0; i < this.transportPricing.length; i++) {
      _option = this.transportPricing[i];

      if (_option.transportCharge.name == "Transport") {
        // _transportOption = _option;
        this.selectedTransportOption = _option;
      }

      if (_option.transportCharge.name == "Travel & Siting (Joining) on site") {
        // _transportOptionJoin = _option;
        this.selectedTransportJoinOption = _option;
      }

      if (this.selectedTransportExtraOption != null && _option.transportCharge.name == "Travel & Siting, including fitment of verandah") {
        this.selectedTransportExtraOption = _option;
      }
    }

    // if (this.selectedTransportOption == null) {
    //   const transportId = this.rentalForm.value.rental_transport;
    //   _id = this.transportPricing.findIndex((obj) => obj.id == transportId);
    //   this.selectedTransport = this.transportPricing[_id];
    // }

    const transport = {
      id: this.selectedTransportOption.id,
      transport: this.selectedTransportOption,
    };

    this.selectedFpProject.transportOne = transport;

    if (this.selectedFpProject.quantity > 1) {
      this.selectedFpProject.transportTwo = transport;
    }

    if (this.selectedTransportExtraOption != null) {
      // if (this.selectedTransportJoinOption != null) {
      const transportJoin = {
        id: this.selectedFpProjectExtraName.toLowerCase() != 'standard' ? this.selectedTransportExtraOption.id : this.selectedTransportJoinOption.id,
        transport: this.selectedFpProjectExtraName.toLowerCase() != 'standard' ? this.selectedTransportExtraOption : this.selectedTransportJoinOption,
      };

      this.selectedFpProject.transportJoin = transportJoin;
      // }
    }

    // const requireJoin = this.hasJoining();
    if (this.hasJoining()) {
      if (this.selectedTransportJoinOption != null) {
        const transportJoin = {
          id: this.selectedTransportJoinOption.id,
          transport: this.selectedTransportJoinOption,
        };

        this.selectedFpProject.transportJoin = transportJoin;
      }
    }

    this.saveToCart();
  }

  addItemProducts() {
    const products = this.selectedFpProject.mappedProducts;

    products.forEach((product, index) => {
      let _product = {
        ...product,
        added_name:
          this.quoteNumber + "," + this.selectedFpProject.unit + "," + index,
        line_item: this.selectedFpProject.idx,
      };
      this.quoteLineItemProducts.push(_product);
    });
  }

  completeQuote() {
    this.saveLineItems();
  }
  confirmSize() {
    this.confirmUnitSizes.open();
  }

  saveProducts() {
    // this.confirmUnitSizes.close();
    let addon = this.quoteLineItemProducts[0];
    this.saveProduct(addon);

    this.store
      .select(getCreatedLineItemConfigs)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((products) => {
        if (products) {
          let productsAdded = products.length;

          if (this.quoteLineItemProducts.length == productsAdded) {
            const route = `${AppRoutes.PWA + "quotes/edit/purchase/" + this.createdQuote.id
              }`;
            this.router.navigate([route]);
          } else {
            if (productsAdded > 0) {
              let itemIdx = this.quoteLineItemProducts[productsAdded];
              this.saveProduct(itemIdx);
            }
          }
        }
      });
  }

  saveProduct(addon) {
    let purchase_line_item = this.getLineItemId(addon.added_name);

    let payload = {
      name: addon.name,
      asset: "",
      quantity: addon.qty,
      unit_price: 0,
      total_price: 0,
      purchase_line_item,
    };

    this.store.dispatch(new CreatePurchaseLineItemConfig(payload));
  }

  getLineItemId(productName) {
    let lineItemId = "";

    for (let i = 0; i < this.addedLineItems.length; i++) {
      let lineItemName = this.addedLineItems[i].unit;
      let unitName = productName.split(",")[1];

      if (lineItemName == unitName) {
        lineItemId = this.addedLineItems[i].id;
        break;
      }
    }
    return lineItemId;
  }

  saveLineItems() {
    let item = this.quoteCart[0];
    this.saveLineItem(item);

    this.store
      .select(getCreatedPurchaseLineItems)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((items) => {
        if (items) {
          this.addedLineItems = items;

          if (this.addedLineItems.length == this.quoteCart.length) {
            if (this.quoteLineItemProducts.length == 0) {
              const route = `${AppRoutes.PWA + "quotes/edit/purchase/" + this.createdQuote.id
                }`;
              this.router.navigate([route]);
            } else {
              this.saveProducts();
            }
          } else {
            if (this.addedLineItems.length > 0) {
              const item = this.quoteCart[this.addedLineItems.length];
              this.saveLineItem(item);
            }
          }
        }
      });
  }

  saveLineItem(item) {
    let payload = {
      name: item.name,
      unit: item.unit,
      description: item.description,
      template: true,
      drawing_no: item.drawingNumber,
      product_configurations: [],
      delivery_charge: this.quoteLineItem.transportOne
        ? this.quoteLineItem.transportOne.id
        : null,
      delivery_charge_qty: this.quoteLineItem.transportOne
        ? this.quoteLineItem.transportOne.quantity
        : null,
      delivery_charge_extra: this.quoteLineItem.transportTwo
        ? this.quoteLineItem.transportTwo.id
        : null,
      delivery_charge_extra_qty: this.quoteLineItem.transportTwo
        ? this.quoteLineItem.transportTwo.quantity
        : null,
      delivery_charge_optional: item.transportJoin
        ? item.transportJoin.id
        : null,
      delivery_charge_variation: item.transportExtra
        ? item.transportExtra.id
        : null,
      quantity: item.quantity,
      quote: this.createdQuote.id,
      floor_planner_sku: item.floorplannerProjectId,
      unit_size: item.size,
      unit_price: item.price,
      total_price: item.price * item.quantity,
      thumbnail: item.thumbnail,
      thumbnail_three_d: item.thumbnail3d,
    };

    this.store.dispatch(new CreatePurchaseLineItem(payload));
  }

  createDiagramClick() {
    this.confirmUnitSizes.close();
    const data = {
      show: true,
      category: this.selectedFpProjectCategoryName,
    };
    this.createDiagram.emit(data);
  }

  confirmUnitSizesClick() {
    this.confirmUnitSizes.open();
  }

  openRemoveUnitModal(purchaseLineItem) {
    this.selectedModalLineItemExtra = null;
    this.selectedModalLineItem = purchaseLineItem;
    this.removeUnitModal.open();
  }

  removeUnit() {
    let removeTemplate = this.quoteCart.filter(
      (item) => item.idx !== this.selectedModalLineItem.idx
    );

    this.quoteCart = removeTemplate;

    this.removeUnitModal.close();
  }

  saveUnit() {
    let payload = {};
    const _unit = this.selectedUnit;

    payload = {
      name: _unit.name,
      quantity: this.purchaseForm.value.quantity,
      quote: this.quote.id,
    };

    this.store.dispatch(
      new UpdatePurchaseLineItem(payload, this.selectedUnit.id)
    );

    this.store
      .select(updatePurchaseLineItemSuccess)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((purchaseLineItem) => {
        if (purchaseLineItem) {
          this.toastrService.showSuccessToaster(
            "Success",
            "Unit updated",
            null
          );
          this.addUnitModal.close();

          this.ngOnInit();
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
